import { IPaged } from '../../../_models/common/IPaged';
import { Component, OnInit } from '@angular/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { CommonService } from 'src/app/shared/services/common.service';
import { IKeyValuePair } from 'src/app/_models/common/common';
import { ISetting } from 'src/app/_models/cms/ISetting';
import { SettingService } from 'src/app/shared/services/setting.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  private readonly PAGE_SIZE = 5;
  statistic: any;
  regions: IKeyValuePair[];
  phases: IKeyValuePair[];
  selectedYear: number;  
  selectedRegion: string = 'Total'; 
  selectedPhase: string = '1';
  financialYears: IKeyValuePair[];
  setting: ISetting;
  loading: boolean = true;
  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'Id', 
    sortDir: 'Descending'
  };
  

  constructor( private service: CommonService,
    private settingService: SettingService
  ) { }

  ngOnInit(): void { 
    this.settingService.getSetting().then(data => {
      this.setting = data;
      this.selectedYear = this.setting?.financialYearId; 
      this.getStatistic();    
    }); 
    
    this.bindDropDown();
    
  }  
  getStatistic() {    
    this.loading = true; 
    this.service.getTotalDisplaced(this.selectedYear, this.selectedPhase, this.selectedRegion)
      .subscribe( 
        (response: any) => {
          if (response) {
            this.statistic = response;
          }
          this.loading = false; // Set loading to false after receiving the response
        },
        (error: any) => {
          console.error('Error fetching statistics:', error);
          this.loading = false; // Set loading to false in case of error
        }
      );  
  }   
  
  bindDropDown() {
    this.service.getRegions().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.regions = response; 
      }
    });
    this.service.getPhases().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.phases = response;
      }
    });
    this.service.getFinancialYears().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.financialYears = response;  
      }
    });
  }

  onYearChange(event: any): void {
    this.selectedYear = event.target.value; 
    this.getStatistic();
  }

  onPhaseChange(event: any): void {
    this.selectedPhase = event.target.value;  // Update selectedPhase based on user input
    this.getStatistic();
  }

  onRegionChange(event: any) {
    this.selectedRegion = event.target.value;
    this.getStatistic();
  }

}